export default __webpack_public_path__ + "locales/login.bua.json";